import type React from 'react';
import { useTranslation } from 'react-i18next';

import { Tag } from '~/components';

interface ListFiltersProps {
  options: string[];
  activeOption?: boolean | null;
  setActiveOption?: (option: boolean | null) => void;
}

export const ListFilters: React.FC<ListFiltersProps> = ({
  options,
  activeOption,
  setActiveOption,
}) => {
  const { t } = useTranslation('settings');

  const handleOptionClick = (option: boolean | null) => {
    if (setActiveOption) {
      setActiveOption(option);
    }
  };

  if (options.length === 0) {
    return <div className="text-subtle text-body-sm">{t('noFilters')}</div>;
  }

  return (
    <ul className="flex flex-wrap gap-y-sm gap-x-sm">
      <Tag
        key={'all'}
        variant={activeOption === null ? 'active' : 'secondary'}
        size="lg"
        onClick={() => handleOptionClick(null)}
      >
        {t('all')}
      </Tag>
      <Tag
        key={'option1'}
        variant={activeOption === true ? 'active' : 'secondary'}
        size="lg"
        onClick={() => handleOptionClick(true)}
      >
        <span>{options[0]}</span>
      </Tag>
      <Tag
        key={'option2'}
        variant={activeOption === false ? 'active' : 'secondary'}
        size="lg"
        onClick={() => handleOptionClick(false)}
      >
        <span>{options[1]}</span>
      </Tag>
    </ul>
  );
};

ListFilters.displayName = 'ListFilters';
